import { axiosInstance } from "./init";

export const axiosBaseQuery =
    () =>
        async ({ url, method = "GET", data, params, headers }) => {
            try {
                const result = await axiosInstance({
                    url,
                    method,
                    data,
                    params,
                    headers,
                });

                return { data: result.data };
            } catch (axiosError) {
                const err = axiosError.response || axiosError;
                return {
                    error: {
                        status: err.status,
                        data: err.data || err.message,
                    },
                };
            }
        };
